import React from 'react';
import $ from 'jquery';
import qs from 'qs';

import { simpleNotification } from '../../utils/notifications';
import IconParticles from '../icon-particles/IconParticles';

import './Contact.scss';

class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
    };
  }


  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.auth.isLoading === true && nextProps.auth.isLoading === false) {
      if (nextProps.auth.errors.hasError) {
        this.setState({
          showingErrors: true,
          errors: nextProps.auth.errors,
        });
      }
    }
  }

  onSubmit = (allFields) => {
    this.submitGForm(allFields);
  }

  submitGForm = (allFields) => {
    const baseURL = 'https://docs.google.com/forms/d/e/1FAIpQLSfImSeGuX-GyABX6L0pWny9FuuzB8xK3FSuQaKac8r-djjTzA/formResponse?';
    const baseGFormFields = {
      submit: 'Submit',
      emailAddress: allFields.email ? allFields.email : '',
      'entry.351391559': allFields.contactName ? allFields.contactName : '',
      'entry.1587419735': allFields.website ? allFields.website : '',
      'entry.591337854': allFields.companyName ? allFields.companyName : '',
      'entry.617606079': allFields.comments ? allFields.comments : '',
    };

    const parameters = qs.stringify(baseGFormFields);

    const completeUrl = `${baseURL}${parameters}`;

    $.ajax({
      type: 'GET',
      url: completeUrl,
      contentType: 'application/x-www-form-urlencoded',
      success: () => {
        this.setState({
          activeModal: true,
        });
        simpleNotification({
          level: 'success',
          title: 'Thank you!',
          message: 'Thanks for reaching out! We\'ll be in touch shortly.',
        });
      },
      error: () => {
        this.setState({
          activeModal: true,
        });
        simpleNotification({
          level: 'success',
          title: 'Thank you!',
          message: 'Thanks for reaching out! We\'ll be in touch shortly.',
        });
      },
    });
  }

  render() {
    return (
      <section className="Contact">
        <section className="Hero">
          <IconParticles />
        </section>
        <section className="MainContact__content-wrapper">
          <header className="MainContact__header">
            <h2 className="MainContact__title">For streamers</h2>
          </header>
          <div className="MainContact__card">
            <div className="MainContact__general-info">
              <p className="MainContact__text">
                Have a general question about Noiz? Contact us at{' '}
                <a className="MainContact__link" rel="noopener noreferrer" target="_blank" href="mailto:hello@noiz.gg">
                  hello@noiz.gg
                </a>
                {' '}or you can join us on{' '}
                <a className="MainContact__link" rel="noopener noreferrer" target="_blank" href="https://twitter.com/noizgg">
                  Twitter
                </a>
                {' '}and{' '}
                <a className="MainContact__link" rel="noopener noreferrer" target="_blank" href="https://discordapp.com/invite/N2PrJxK">
                  Discord
                </a>
                !
              </p>
            </div>
            <div className="MainContact__support-info">
              <p className="MainContact__text">
                Need support?
                <br />
                Contact us at{' '}
                <a className="MainContact__link" rel="noopener noreferrer" target="_blank" href="mailto:support@noiz.gg">
                  support@noiz.gg
                </a>
              </p>
            </div>
          </div>
        </section>
      </section>);
  }
}

// Contact.propTypes = {
//
// };

export default Contact;
